(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legu-product-installments"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(root, cents) {
      const format = root.dataset.moneyFormat || '$' + '{' + '{amount}}';
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      const showDecimals = root.dataset.showDecimals === 'true';
      if (!match) return String((cents / 100).toFixed(showDecimals ? 2 : 0));

      const token = match[1];
      const selectedSeparator = root.dataset.decimalSeparator || 'comma';
      let thousands = ',';
      let decimal = '.';
      if (selectedSeparator === 'comma') {
        thousands = '.';
        decimal = ',';
      } else if (selectedSeparator === 'point') {
        thousands = ',';
        decimal = '.';
      } else if (token.includes('comma_separator')) {
        thousands = '.';
        decimal = ',';
      } else if (token.includes('space_separator')) {
        thousands = ' ';
        decimal = ',';
      } else if (token.includes('apostrophe_separator')) {
        thousands = "'";
      }

      const precision = showDecimals ? 2 : 0;
      const fixed = Number(cents / 100 || 0).toFixed(precision).split('.');
      fixed[0] = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const amount = fixed.length > 1 ? fixed[0] + decimal + fixed[1] : fixed[0];
      return format.replace(match[0], amount);
    }

    function updateAmount(root, price) {
      const amountElement = root.querySelector('.legu-product-installments__amount');
      if (!amountElement) return;
      const installmentCount = Math.max(1, Number(root.dataset.installments) || 1);
      let installmentPrice = Number(price || 0) / installmentCount;
      if (root.dataset.showDecimals !== 'true') {
        installmentPrice = Math.round(installmentPrice / 100) * 100;
      }
      amountElement.textContent = formatMoney(root, installmentPrice);
    }

    function initialize(root) {
      if (root.dataset.leguInstallmentsReady === 'true') return;
      root.dataset.leguInstallmentsReady = 'true';
      const productId = String(root.dataset.productId || '');
      const onVariantChange = function (event) {
        const variant = event.detail && event.detail.variant;
        if (!variant || typeof variant.price === 'undefined') return;
        if (variant.product_id && productId && String(variant.product_id) !== productId) return;
        updateAmount(root, variant.price);
      };
      root.leguVariantHandler = onVariantChange;
      document.addEventListener('on:variant:change', onVariantChange);
      updateAmount(root, root.dataset.price);
    }

    function initializeWithin(container) {
      container.querySelectorAll('[data-legu-product-installments]').forEach(initialize);
    }

    function boot() {
      initializeWithin(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeWithin(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-legu-product-installments]').forEach(function (root) {
        if (root.leguVariantHandler) {
          document.removeEventListener('on:variant:change', root.leguVariantHandler);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
